export default "__VITE_ASSET__8p5omWCU__"